export {default as VmLAnakColorIcon} from './VmLAnakColorIcon'
export {default as VmPDewasaColorIcon} from './VmPDewasaColorIcon'
export {default as VmLDewasaColorIcon} from './VmLDewasaColorIcon'
export {default as VmPAnakColorIcon} from './VmPAnakColorIcon'
export {default as VmLAnakGrayIcon} from './VmLAnakGrayIcon'
export {default as VmPDewasaGrayIcon} from './VmPDewasaGrayIcon'
export {default as VmLDewasaGrayIcon} from './VmLDewasaGrayIcon'
export {default as VmPAnakGrayIcon} from './VmPAnakGrayIcon'
export {default as VmPPDefaultIcon} from './VmPPDefaultIcon'
